import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { SpaceKey } from "popopo-msg"
import { api } from "../../core"

export const SpaceFriendsCallCreateForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const form = useForm<{}>({
    mode: "onBlur",
  })

  const onLiveCreate = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/push/call-pushes", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          kind: "space-friends-call",
          spaceKey: props.spaceKey,
        }
      })
    } catch (e) {
      console.error(e)
    }
  }


  return (
    <>
      <form className="d-flex flex-column gap-3 w-100" onSubmit={form.handleSubmit(onLiveCreate)}>
        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onLiveCreate)}>
          Call friends
        </button>
      </form>
    </>
  )
}
